<template>
  <div>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      :radio-config="{ highlight: true }"
      row-id="id"
      :loading="loading"
      :data="tableData"
    >
      <vxe-table-column type="radio" width="60" />
      <vxe-table-column
        field="invoiceTitle"
        title="发票抬头"
        min-width="150"
        sortable
      />
      <vxe-table-column
        field="totalAmount"
        title="发票金额"
        min-width="120"
        sortable
      />
      <vxe-table-column
        field="taxRegistrationNumber"
        title="税务登记证号"
        min-width="150"
        sortable
      />
      <vxe-table-column
        field="bankName"
        title="基本开户银行"
        min-width="130"
        sortable
      />
      <vxe-table-column
        field="accountNumber"
        title="基本开户账号"
        min-width="165"
        sortable
      />
      <vxe-table-column
        field="registeredAddress"
        title="注册场所地址"
        min-width="140"
        sortable
      />
      <vxe-table-column
        field="registeredFixedPhone"
        title="注册固定电话"
        min-width="130"
        sortable
      />

      <!-- <vxe-table-column
        field="type"
        title="开票方式"
        :formatter="formatterStatus"
        min-width="150"
        sortable
      /> -->
    </vxe-table>
    <!-- 开票信息 -->
    <!-- <Info ref="infoRefs" :latestRecord="latestRecord"></Info> -->
    <div style="margin-top:20px;">
      <div style="margin-bottom:9px;font-weight:bold;font-size:16px;">
        发票备注:
      </div>
      <el-input
        style="width:480px;margin-left:40px;"
        type="textarea"
        :rows="3"
        placeholder="请输入发票备注"
        v-model="remark"
        maxlength="190"
        show-word-limit
      ></el-input>
    </div>
    <!-- 按钮 -->
    <div class="btn_box_end">
      <el-button @click="quxiao()">
        取消
      </el-button>
      <el-button type="primary" @click="changeConfirm">
        确定
      </el-button>
    </div>

    <!-- <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />-->
  </div>
</template>
<script>
import Info from "@/components/InvoiceMessage";
import { invoice, invoiceMessage } from "@/api/invoice";

export default {
  components: {
    Info
  },
  props: {
    totalAmount: {
      type: Number,
      default: 0
    },
    latestRecord: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tableData: [],
      loading: false,
      Freightamount: "",
      Invoiceamount: "",
      listQuery: {
        pageNum: 1,
        pageSize: 1000,
        total: 0
      },
      type2: [],
      object: {
        invoiceMessageCode: "",
        detailCodes: ""
      },
      remark: ""
    };
  },
  created() {},
  methods: {
    invoicelist(s, c) {
      this.object.detailCodes = c;
      this.loading = true;
      invoiceMessage(s).then(response => {
        this.tableData = response.data.records;
        if (this.tableData != null && this.tableData.length > 0) {
          this.tableData[0].totalAmount = this.totalAmount + "元";
        }
        this.loading = false;
      });
    },
    formatterStatus({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "现付开票";
        case 1:
          return "到付开票";
        case 2:
          return "代付开票";
      }
    },
    changeConfirm() {
      const Code = this.$refs.xTable.getRadioRecord();
      if (Code == null) {
        this.$message({ message: "请选择发票抬头", type: "warning" });
        return;
      }
      let info = "请您确认是否需要填写发票备注";
      this.$confirm(info, "提示", {
        confirmButtonText: "继续申请",
        cancelButtonText: "去填写",
        type: "warning"
      })
        .then(() => {
          this.requestclick();
        })
        .catch(() => {});
    },

    requestclick() {
      // let info = this.$refs.infoRefs.getFormInfo();
      // if (info.loadPlace.length && !info.unloadPlace.length) {
      //   this.$message({
      //     message: "起运地和目的地必须同时选择，请完善信息",
      //     type: "warning"
      //   });
      //   return;
      // }
      // if (!info.loadPlace.length && info.unloadPlace.length) {
      //   this.$message({
      //     message: "起运地和目的地必须同时选择，请完善信息",
      //     type: "warning"
      //   });
      //   return;
      // }
      // console.log(info);
      this.object.invoiceMessageCode = "";
      const Code = this.$refs.xTable.getRadioRecord();
      if (Code == null) {
        this.$message({ message: "请选择发票抬头", type: "warning" });
      } else {
        this.object.invoiceMessageCode = Code.code;
        // let checked = this.$refs.infoRefs.checked;
        // let hasFormData = this.$refs.infoRefs.hasFormData;
        console.log("========", this.$refs.infoRefs);
        // if (checked && !hasFormData) {
        //   this.$message({
        //     message: "您已选择备注同步至发票，请填写备注信息",
        //     type: "warning"
        //   });
        //   return;
        // }
        // if (checked) {
        this.object = { ...this.object, remark: this.remark };
        // }
        const rLoading = this.openLoading();
        invoice(this.object).then(response => {
          if (response.status == 0) {
            rLoading.close();
            this.$message({
              message: response.msg,
              type: "success"
            });
          }
          this.$emit("event1");
        });
      }
    },
    quxiao() {
      this.$emit("event1");
    }
  }
};
</script>

<style>
.btn_box_end {
  display: flex;
  justify-content: flex-end;
  margin-right: 20px;
  margin-bottom: 30px;
}
</style>
